import axios from 'axios';
import OktaUserDetails from '../Helpers/OktaUserDetails';
import { authHeader } from '../Helpers';
import router from '../router/router';

const oktaUserDetails = new OktaUserDetails();
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['UserId'] = oktaUserDetails.getUserId();
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

axios.interceptors.request.use(config => {
        config.headers.post = {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    config.headers.Authorization = authHeader();
        return config;
})

// intercept the global error
axios.interceptors.response.use((response) => { 
    return response
}, function (error) {
    if (error.response.status === 401) {
        router.push('/UnAuthorized');
        return
    }
    return Promise.reject(error)
})
